import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { isModuleEnabled, ROUTE_TO_MODULE } from '../lib/modules';

/**
 * Wraps a Route element. If the current path maps to a module key and that module
 * is NOT in the user's enabled_modules list, redirects to /doctor/module-disabled.
 *
 * Backwards-compat: when user has no package or enabled_modules is empty, the guard
 * is a no-op (user can access everything).
 */
export const ModuleGuard = ({ children }) => {
  const { modulesState, user, isLoading } = useAuth();
  const location = useLocation();

  // Let ProtectedRoute handle auth; also don't interfere during initial load
  if (isLoading) return children;
  if (user?.role !== 'doctor') return children;

  const moduleKey = ROUTE_TO_MODULE[location.pathname];
  if (!moduleKey) return children;

  if (!isModuleEnabled(modulesState, moduleKey)) {
    const qs = new URLSearchParams({ module: moduleKey }).toString();
    return <Navigate to={`/doctor/module-disabled?${qs}`} replace />;
  }

  return children;
};

export default ModuleGuard;
